module.exports = __webpack_public_path__ + "static/media/twitter.c37cd965.svg";